const { AuthServices, AuthServiceMethods, TimeoutLabels } = require('./constants');
const { fetchApi, clearPendingTimeout } = require('./utils/common');
const { handleGenerateOrRefreshTokenResponse } = require('./utils/token');

const AuthManager = function AuthManager(options) {
  const { authApiEndpoint, listeners } = options ?? {};
  const { onTokenExpireCallback, onTokenRefreshCallback, onTokenGeneratedCallback } =
    listeners || {};

  this.endpoint = authApiEndpoint || 'https://wapi.dev.winamax.fr';
  this.onTokenExpireCallback = onTokenExpireCallback;
  this.onTokenRefreshCallback = onTokenRefreshCallback;
  this.onTokenGeneratedCallback = onTokenGeneratedCallback;
  this.timeoutRefs = {
    [TimeoutLabels.REFRESH_TOKEN]: null,
    [TimeoutLabels.INVALIDATE_TOKEN]: null,
  };
};

AuthManager.prototype.initWithJWT = function initWithJWT(jwt, expirationDelay) {
  const { jwt: currentJWT, expirationDelay: currentExpirationDelay } =
    handleGenerateOrRefreshTokenResponse(this, jwt, expirationDelay);

  if (this.onTokenGeneratedCallback) {
    this.onTokenGeneratedCallback(currentJWT, currentExpirationDelay);
  }

  return { jwt: currentJWT, expirationDelay: currentExpirationDelay };
};

AuthManager.prototype.generateToken = async function generateToken(
  authorizationCode,
  authChallenge
) {
  if (authorizationCode && authChallenge) {
    const res = await fetchApi(this.endpoint, {
      method: AuthServiceMethods.GENERATE,
      ns: AuthServices.GENERATE,
      params: { authorization_code: authorizationCode, challenge: authChallenge },
    });

    if (res && res.result) {
      const { token: jwt, expiration_delay: expirationDelay } = res.result;

      if (jwt && expirationDelay) {
        const { jwt: currentJWT, expirationDelay: currentExpirationDelay } =
          handleGenerateOrRefreshTokenResponse(this, jwt, expirationDelay);

        if (this.onTokenGeneratedCallback) {
          this.onTokenGeneratedCallback(currentJWT, currentExpirationDelay);
        }
        return { jwt: currentJWT, expirationDelay: currentExpirationDelay };
      }
    }

    return { error: 'General problem' };
  }

  return null;
};

AuthManager.prototype.getToken = function getToken() {
  return this.jwt;
};

AuthManager.prototype.logout = function logout() {
  this.jwt = null;
  clearPendingTimeout(this.timeoutRefs);
  if (this.onTokenExpireCallback) {
    this.onTokenExpireCallback();
  }
};

AuthManager.prototype.getOTT = async function getOTT() {
  if (this.jwt) {
    const res = await fetchApi(this.endpoint, {
      method: AuthServiceMethods.GENERATE_OTT,
      ns: AuthServices.OTT,
      params: { jwt: this.jwt },
    });

    if (res && res.result) {
      const { token: ott } = res.result;

      if (ott) {
        return ott;
      }
    }
  }

  return null;
};

module.exports = AuthManager;
